import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useMoreStockContext } from "../../context/MoreStockContext";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";

const CACHE_TTL = 1000 * 60 * 10;
const TRENDING_KEY = "trending_cache";

const ACTIVE_KEY = "active_cache";
const cache = {
  active: null,
  trending: null,
};

const AllGlobal = () => {
  const { type } = useParams();
  const [alphaStocks, setAlphaStocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedStock, setSelectedStock] = useState(5);
  const { data } = useMoreStockContext();
  console.log("Context data", data);
  // const BASE_URL = "http://localhost:8000";
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const dropDown1 = [
    { id: 1, name: "Top 5 stocks", value: 5 },
    { id: 2, name: "Top 10 stocks", value: 10 },
    // { id: 3, name: "Top 15 stocks", value: 15 },
    // { id: 4, name: "Top 20 stocks", value: 20 },
  ];
  // const fetchTrendingData = async () => {
  //   try {
  //     setLoading(true);

  //     // 🧠 Check cache
  //     const cached = localStorage.getItem(TRENDING_KEY);
  //     if (cached) {
  //       const parsed = JSON.parse(cached);
  //       const isExpired = Date.now() - parsed.timestamp > CACHE_TTL;

  //       if (!isExpired) {
  //         console.log("✅ Using cached trending data");
  //         setAlphaStocks(parsed.data);
  //         setLoading(false);
  //         return;
  //       }

  //       console.log("⚠️ Cache expired, fetching new data...");
  //     }

  //     const response = await axios.get(`${BASE_URL}/api/alphatrending`);
  //     const data = response.data;

  //     localStorage.setItem(
  //       TRENDING_KEY,
  //       JSON.stringify({
  //         timestamp: Date.now(),
  //         data,
  //       })
  //     );

  //     console.log("💾 Cached new trending data");
  //     setAlphaStocks(data);
  //   } catch (error) {
  //     console.error("❌ Error fetching trending data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   fetchTrendingData();
  // }, [type]);
  // console.log("Alpa Stocks", alphaStocks);

  let dataToRender;
  if (type === "gainers") {
    // dataToRender = alphaStocks?.top_gainers?.slice(0, selectedStock);
    dataToRender = data?.slice(0, selectedStock);
  } else if (type === "losers") {
    // dataToRender = alphaStocks?.top_losers?.slice(0, selectedStock);
    dataToRender = data?.slice(0, selectedStock);
  } else {
    // dataToRender = alphaStocks?.most_actively_traded?.slice(0, selectedStock);
    dataToRender = data?.slice(0, selectedStock);
  }
  console.log("Data to Render", dataToRender);
  const navigate = useNavigate();
  // const handleManualRefresh = async () => {
  //   await fetchTrendingData();
  // };
  const formatVolume = (volume) => {
    return typeof volume === "string"
      ? Number(volume).toLocaleString()
      : volume.toLocaleString();
  };
  return (
    <>
      <div className="stocks">
        {/* <div style={{ textAlign: "right", margin: "10px" }}>
          <button
            className="rec-btn"
            onClick={handleManualRefresh}
            disabled={loading}
          >
            {loading ? "Refreshing..." : "Refresh Data"}
          </button>
        </div> */}
        <div
          className="dropdown"
          style={{ display: "flex", justifyContent: "center", gap: "3rem" }}
        >
          <select onChange={(e) => setSelectedStock(Number(e.target.value))}>
            {dropDown1.map((item) => (
              <option value={item.value} key={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <div className="stock-table-container">
            {/* <table className="stock-table">
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Price</th>
                  <th>% Change</th>
                  <th>Volume</th>
                  <th>Recommendation</th>
                </tr>
              </thead>
              <tbody>
                {dataToRender?.map((stock) => (
                  <tr
                    key={stock.ticker}
                    className="stock-row"
                    // onClick={() => navigate(`/stockdetail/${stock.ticker}`)}
                  >
                    <td>{stock?.ticker}</td>
                    <td>{stock.price}</td>

                    <td
                      style={{
                        color:
                          parseFloat(stock.change_percentage) >= 0
                            ? "#2fd18a"
                            : "#f87171",
                      }}
                    >
                      {parseFloat(stock.change_percentage).toFixed(2)}%
                    </td>

                    <td>{formatVolume(stock.volume)}</td>
                    <td>
                      <button
                        className="rec-btn"
                        onClick={() =>
                          navigate(`/globalstock/${stock?.ticker}`)
                        }
                      >
                        Recommendation
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table> */}
            <div
              className="market-cards"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div className="market-card" style={{ width: "300px" }}>
                <div className="market-card-title">
                  <h2 className="card-title">
                    Top{" "}
                    {type === "gainers"
                      ? "Gainers"
                      : type === "losers"
                      ? "Losers"
                      : type === "active"
                      ? "Active"
                      : ""}
                  </h2>
                  <IoMdTrendingUp style={{ color: "#249966 " }} />
                </div>

                {dataToRender?.map((stock) => (
                  <div className="card-row" key={stock.ticker_id}>
                    <div className="left">
                      <p className="name">{stock?.ticker}</p>
                      <p className="price">₹{stock.price}</p>
                    </div>

                    <div className="right">
                      <p
                        className="change"
                        style={{
                          color:
                            parseFloat(stock.change_percentage) >= 0
                              ? "#249966"
                              : "#f87171",
                        }}
                      >
                        {parseFloat(stock.change_percentage).toFixed(2) > 0
                          ? `+${parseFloat(stock.change_percentage).toFixed(2)}`
                          : `${parseFloat(stock.change_percentage).toFixed(2)}`}
                        %
                      </p>
                      <button
                        className="buy-btn"
                        onClick={() =>
                          navigate(`/globalstock/${stock?.ticker}`)
                        }
                      >
                        {type === "gainers"
                          ? "Buy"
                          : type === "losers"
                          ? "Sell"
                          : type === "active"
                          ? "Trade"
                          : ""}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllGlobal;
